"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var IsFalseCondition = (function () {
    function IsFalseCondition(name, predicate) {
        this.name = name;
        this.predicate = predicate;
    }
    IsFalseCondition.prototype.evaluate = function (_) {
        return !this.predicate();
    };
    IsFalseCondition.prototype.describe = function () {
        return "".concat(this.name, ".isFalse()");
    };
    return IsFalseCondition;
}());
exports.default = IsFalseCondition;
